import React from 'react';
import { Button, Flex, Typography } from 'antd';
import { CopyIcon } from 'components/cwo-icons';
import ZendeskWidget from 'components/zendesk-widget';
import { shape, string } from 'prop-types';
import CompanySelector from './CompanySelector';
import OnboardingToggle from './OnboardingToggle';

const { Link, Paragraph } = Typography;
const COPYABLE_KEYS = new Set(['email', 'phone']);

const MenuLink = ({ item, currentLocale }) => {
  const { key, label, path } = item;

  const handleCopyClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      await navigator.clipboard.writeText(label);
    } catch {
      // Clipboard access can be denied; copying is best-effort.
    }
  };

  const defaultLink = (content) => {
    if (!path) {
      return (
        <span className="navigation-top-menu__link">
          <Paragraph>{content}</Paragraph>
        </span>
      );
    }

    return (
      <Link
        href={path}
        className="navigation-top-menu__link"
        {...(item?.target ? { target: item.target, rel: 'noopener noreferrer' } : {})}
      >
        <Paragraph>{content}</Paragraph>
      </Link>
    );
  };

  const copyableLink = () => (
    <Flex align="center" justify="space-between" gap={8}>
      {defaultLink(label)}
      <Button
        type="text"
        size="small"
        icon={<CopyIcon />}
        onClick={handleCopyClick}
        aria-label="Copy"
      />
    </Flex>
  );

  const languageLabel = () => {
    const { children } = item;
    const findCurrentLanguage = children.find((child) => child.key === currentLocale);

    return (
      <>
        <span>{label}</span>
        <span style={{ fontWeight: '400', color: '#696f88' }}>
          {findCurrentLanguage.label}
        </span>
      </>
    );
  };

  const userLabel = () => {
    const style = { fontWeight: '400', fontSize: '12px', color: '#696f88' };
    const { email } = item;

    return (
      <Flex vertical align="start">
        <span>{label}</span>
        <span style={style}>
          {email}
        </span>
      </Flex>
    );
  };

  switch (key) {
    case 'zendesk-widget':
      return <ZendeskWidget />;
    case 'onboarding-toggle':
      return <OnboardingToggle item={item} />;
    case 'account-language':
      return defaultLink(languageLabel());
    case 'account-user':
      return defaultLink(userLabel());
    case 'company-company':
      return item.memberships.length > 1 ? <CompanySelector item={item} /> : defaultLink(label);
    default:
      return COPYABLE_KEYS.has(key) ? copyableLink() : defaultLink(label);
  }
};

MenuLink.propTypes = {
  item: shape({}).isRequired,
  currentLocale: string.isRequired,
};

export default MenuLink;
